import { faAward, faPassport, faUser /* faBullhorn */ } from '@fortawesome/free-solid-svg-icons'
import { REWARDS_ENABLED } from './helpers/rewardsEnabled'

export const homeRoutes = {
  name: 'Inicio',
  to: '/dashboard/app',
  exact: true,
  iconsrc: 'Icono Inicio 2.png'
}

export const condominiumRoutes = {
  name: 'Condominio',
  iconsrc: 'Icono Condominio 2.png',
  children: [
    { to: '/dashboard/banks', name: 'Bancos', iconsrc: 'Icono Bancos 2.png' },
    { to: '/dashboard/finance', name: 'Finanzas', iconsrc: 'Icono Finanzas 2.png' },
    { to: '/dashboard/providers', name: 'Proveedores', iconsrc: 'Icono Proveedores 2.png' },
    // { to: '/dashboard/feed', name: 'Muro de noticias', icon: faBullhorn },
    { to: '/dashboard/surveys', name: 'Encuestas/Votaciones', iconsrc: 'Icono Encuestas y votaciones 2.png' },
    { to: '/dashboard/security', name: 'Seguridad', iconsrc: 'Icono Seguridad 2.png' },
    { to: '/dashboard/areas', name: 'Areas comunes', iconsrc: 'Icono Areas Comunes 2.png' }
  ]
}

export const financeRoute = {
  name: 'Mis finanzas',
  iconsrc: 'Icono Finanzas 2.png',
  to: '/dashboard/my/finance'
}

export const renterRoute = {
  to: '/dashboard/renter',
  name: 'Inquilinos',
  icon: faUser
}

export const visitorRoute = {
  to: '/dashboard/visitors',
  name: 'Visitas',
  iconsrc: 'Icono Visitantes 2.png'
}

export const userAuthRoute = {
  to: '/errors',
  name: 'Usuarios autorizados',
  icon: faPassport
}

export const parkingRoute = {
  name: 'Mis parqueos',
  iconsrc: 'Icono Parqueaderos 2.png',
  to: '/dashboard/parking/my/stalls'
}

// HO-TASK-282: usa un ícono de FontAwesome mientras diseño entrega el PNG
// propio del módulo; al tenerlo, cambiar `icon` por `iconsrc: 'Icono Rewards 2.png'`.
export const rewardsRoute = {
  name: 'Homelan Rewards',
  icon: faAward,
  to: '/dashboard/rewards'
}

export const complainRoute = {
  name: 'Sugerencias',
  iconsrc: 'Icono Centro de quejas 2.png',
  to: '/dashboard/complaints'
}

const propertyRoutes = [
  homeRoutes,
  condominiumRoutes,
  financeRoute,
  ...(REWARDS_ENABLED ? [rewardsRoute] : []),
  visitorRoute,
  parkingRoute,
  complainRoute
]

export default propertyRoutes
